import { createRouter, createWebHistory } from 'vue-router'
import UserDashboard from '../views/dashboard/UserDashboard.vue'
import UserDashboardNew from '../views/dashboard/UserDashboardNew.vue'
import MyAccount from '../views/dashboard/MyAccount.vue'
import LogIn from '../views/LogIn.vue'
import ViewInvoices from '../views/dashboard/ViewInvoices.vue'
import UploadInvoice from '../views/dashboard/UploadInvoice.vue'
import CreateInvoice from '../views/dashboard/CreateInvoice.vue'
import InvoiceApproval from '../views/dashboard/InvoiceApproval.vue'
import NewInvoicePage from "../views/dashboard/NewInvoicePage"
import Customers from "../views/dashboard/CustomerTable.vue"
import ItemsTable from "../views/dashboard/ItemsTable.vue"
import ReportForm from "../views/dashboard/ReportForm.vue"
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import UserManagement from '../views/admin/UserManagement.vue'
import EntityManagement from '../views/admin/EntityManagement.vue'
import ApiKeyManagement from '../views/admin/ApiKeyManagement.vue'
import EnrichmentManagement from '../views/admin/EnrichmentManagement.vue'
import UserAuditLogs from '@/views/admin/UserAuditLogs.vue'
import AdminActivityLogs from '@/views/admin/AdminActivityLogs.vue'
import BroadcastMessage from '@/views/admin/BroadcastMessage.vue'
import store from '../store'
import GroupPermissionManagement from '@/views/admin/GroupPermissionManagement.vue'
import UserLoginReport from '@/views/admin/UserLoginReport.vue'
import AppConfiguration from '@/views/admin/AppConfiguration.vue'
import SystemLogs from '@/views/admin/SystemLogs.vue'
import AIKnowledgeBase from '@/views/admin/AIKnowledgeBase.vue'
import ValidationRule from '@/views/mapping/ValidationRule.vue'
import MappingSettings from '../views/mapping/MappingSettings.vue'
import MappingRule from '@/views/mapping/MappingRule.vue'
import MasterCodeLog from '@/views/admin/MasterCodeLog.vue'
import ApprovalRequests from '@/views/admin/ApprovalRequests.vue'
import SupportApp from '@/views/dashboard/SupportApp.vue'
import AISupportPage from '@/views/dashboard/AISupportPage.vue'
import ConsolidateInvoice from '@/views/dashboard/ConsolidateInvoice.vue'
import WorkerMonitoring from '@/views/dashboard/WorkerMonitoring.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: LogIn
  },
  {
    path: '/log-in',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: UserDashboard,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/new',
    name: 'UserDashboardNew',
    component: UserDashboardNew,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/invoices',
    name: 'Invoices',
    component: ViewInvoices,
    props: route => ({ selectedTab: route.query.tab || 'All' }),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/invoices/upload',
    name: 'UploadInvoice',
    component: UploadInvoice,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/invoices/create',
    name: 'AddInvoice',
    component: CreateInvoice,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/invoices/edit/:uuid',
    name: 'EditInvoice',
    component: CreateInvoice,
    meta: {
      requireLogin: true
    },
    props: true
  },
  {
    path: '/dashboard/invoices/approval',
    name: 'InvoiceApproval',
    component: InvoiceApproval,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/self-test',
    name: 'SelfTest',
    component: () => import('../views/dashboard/SelfTest.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/create-document',
    name: 'NewInvoicePage',
    component: NewInvoicePage,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/integration-monitor',
    name: 'IntegrationMonitor',
    component: () => import('../views/dashboard/IntegrationMonitor.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/support',
    name: 'SupportApp',
    component: SupportApp,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/ai-support',
    name: 'AISupportPage',
    component: AISupportPage,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/itemstable',
    name: 'ItemsTable',
    component: ItemsTable,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/my-account',
    name: 'MyAccount',
    component: MyAccount,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/worker-monitoring',
    name: 'WorkerMonitoring',
    component: WorkerMonitoring,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/report',
    name: 'ReportForm',
    component: ReportForm,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/dashboard/consolidate-invoice',
    name: 'ConsolidateInvoice',
    component: ConsolidateInvoice,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/user-management',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/entity-management',
    name: 'EntityManagement',
    component: EntityManagement,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/approval-requests',
    name: 'ApprovalRequests',
    component: ApprovalRequests,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/broadcast-messages',
    name: 'BroadcastMessages',
    component: BroadcastMessage,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/api-key-management',
    name: 'ApiKeyManagement',
    component: ApiKeyManagement,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/enrichment-management',
    name: 'EnrichmentManagement',
    component: EnrichmentManagement,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/permission-management',
    name: 'PermissionManagement',
    component: GroupPermissionManagement,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/user-audit-logs',
    name: 'UserAuditLogs',
    component: UserAuditLogs,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/admin-activity-logs',
    name: 'AdminActivityLogs',
    component: AdminActivityLogs,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/master-code-logs',
    name: 'MasterCodeLog',
    component: MasterCodeLog,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/user-login-log',
    name: 'UserLoginReport',
    component: UserLoginReport,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/app-configuration',
    name: 'Application Configuration',
    component: AppConfiguration,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/system-logs',
    name: 'SystemLogs',
    component: SystemLogs,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/admin/ai-knowledge-base',
    name: 'AIKnowledgeBase',
    component: AIKnowledgeBase,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/data-mapping',
    name: 'DataMapping',
    component: MappingSettings,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/data-mapping/validation-rules',
    name: 'Validation Rule',
    component: ValidationRule,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  },
  {
    path: '/data-mapping/mapping-rules',
    name: 'Mapping Rule',
    component: MappingRule,
    meta: {
      requireLogin: true,
      requireAdmin: true
    }
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
    next('/log-in')
  } else if (to.matched.some(record => record.meta.requireAdmin) && !store.getters.isSuperAdmin) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
